module.exports = __webpack_public_path__ + "img/Article-image20.ba3720f6.jpg";